<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  agents: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
});
const selected = defineModel({ type: Array, required: true });
const { t } = useI18n();
const query = ref('');
const matches = computed(() => {
  const search = query.value.trim().toLowerCase();
  return props.agents.filter(agent =>
    (agent.name || agent.email).toLowerCase().includes(search)
  );
});
const toggle = (id, checked) => {
  selected.value = checked
    ? [...new Set([...selected.value, id])]
    : selected.value.filter(value => value !== id);
};
</script>

<template>
  <fieldset :disabled="disabled" class="m-0 min-w-0 border-0 p-0">
    <legend class="mb-2 text-sm font-medium text-n-slate-12">
      {{ t('INTERNAL_CHAT.DM_RECIPIENT') }}
    </legend>
    <Input
      v-model="query"
      :disabled="disabled"
      :label="t('INTERNAL_CHAT.SEARCH_RECIPIENTS')"
    />
    <div class="mt-2 grid max-h-56 gap-2 overflow-y-auto">
      <label
        v-for="agent in matches"
        :key="agent.id"
        class="flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1 text-sm text-n-slate-12"
      >
        <Checkbox
          :model-value="selected.includes(agent.id)"
          :disabled="disabled"
          @update:model-value="toggle(agent.id, $event)"
        />
        <span class="min-w-0 truncate">{{ agent.name || agent.email }}</span>
      </label>
    </div>
    <p class="mt-2 mb-0 text-xs text-n-slate-11">
      {{ t('INTERNAL_CHAT.DM_SELECTED', { count: selected.length }) }}
    </p>
  </fieldset>
</template>
